import React, { useState } from "react";

const getFileExtension = (url) => {
  try {
    const pathname = new URL(url).pathname;
    const filename = pathname.split("/").pop() || "";
    const match = filename.match(/\.(\w+)$/);
    return match ? match[1].toLowerCase() : null;
  } catch (error) {
    console.error("Invalid URL", error);
    return null;
  }
};

const FilePreviewer = ({ url }) => {
  const [loading, setLoading] = useState(true);

  const handleLoad = () => {
    setLoading(false);
  };
  const extension = getFileExtension(url);

  if (!extension)
    return (
      <div className="position-relative">
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <div>Loading...</div>
          </div>
        )}
        <iframe
          src={url}
          title="PDF Preview"
          width="100%"
          height="500px"
          style={{ border: "none" }}
          onLoad={handleLoad}
        />
      </div>
    );

  if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
    return (
      <div>
        <img
          src={url}
          alt="Preview"
          style={{ maxWidth: "100%", maxHeight: "500px" }}
        />
      </div>
    );
  }

  if (extension === "pdf") {
    return (
      <div className="position-relative">
        {loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 10,
            }}
          >
            <div>Loading...</div>
          </div>
        )}
        <iframe
          src={url}
          title="PDF Preview"
          width="100%"
          height="500px"
          style={{ border: "none" }}
          onLoad={handleLoad}
        />
      </div>
    );
  }

  return <div>Preview not available for .{extension} files.</div>;
};

export default FilePreviewer;
